/* eslint-disable react-hooks/exhaustive-deps */
import InputForm from "../../../components/inputs/InputForm";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { Loader, toaster } from "rsuite";
import { useEffect, useState } from "react";
import InputSearch from "../../../components/inputs/InputSelectSearch";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Area } from "../../../types/compl-archivos/Area";
import { Region } from "../../../types/compl-archivos/Region";
import { Instancia } from "../../../types/compl-archivos/Instancia";
import { Distrito } from "../../../types/compl-archivos/Distrito";
import { isValid } from "../../../libs/formats";

const defaultForm: AreaForm = {
  instance: "",
  district: "",
  name: "",
  areaKey: "",
  pArea: "",
  email: "",
  region: "",
};

const formSchema = Yup.object().shape({
  instance: Yup.string().required("Seleccione una instancia"),
  district: Yup.string().required("Seleccione un distrito"),
  name: Yup.string().required("Ingrese un nombre"),
  // areaKey: Yup.string().required("Ingrese una clave de área"),
  // email: Yup.string()
  //   .required("Ingrese un correo electrónico")
  //   .email("Ingrese un correo electrónico valido"),
  region: Yup.string().required("Seleccione una región"),
});

export default function Form({
  setOpen,
  selected,
  regiones,
  instancias,
}: {
  setOpen: any;
  selected?: Area;
  regiones: Region[];
  instancias: Instancia[];
}) {
  const [loading, setLoading] = useState<boolean>(true);
  const [distritos, setDistritos] = useState<any>({});
  const [areas, setAreas] = useState<Area[]>([]);

  useEffect(() => {
    getAreas();
  }, []);

  async function getAreas() {
    const res = await peticionBack({}, "/areas", "GET", false, toaster);
    if (res) setAreas(res.data);
    setLoading(false);
  }

  const {
    handleSubmit,
    handleReset,
    handleBlur,
    setFieldValue,
    setValues,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: defaultForm,
    validationSchema: formSchema,
    onSubmit: (values) => {
      swalAction(
        save,
        `${selected ? "Editar" : "Guardar"} Área`,
        `¿Desea ${selected ? "editar" : "guardar"} esta área?`,
        "question"
      );
    },
    onReset: () => {
      setOpen(false);
    },
  });

  function onChange({ target }: { target: any }) {
    if (target.name === "region" && !isValid(target.value)) {
      setFieldValue("district", "");
    }
    setFieldValue(target.name, target.value);
  }

  async function getDistritos() {
    if (distritos[values.region as string]) return;
    const query = JSON.stringify({ region: { $eq: values.region } });
    const res = await peticionBack(
      {},
      `/distritos?query=${query}`,
      "GET",
      false,
      toaster
    );
    if (res) {
      const cpy = { ...distritos };
      cpy[values.region] = res.data;
      setDistritos(cpy);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (selected) {
      setValues(
        {
          instance: (selected.instance as Instancia)._id as string,
          district: (selected.district as Distrito)._id as string,
          name: selected.name,
          areaKey: selected.areaKey,
          pArea: (selected.pArea as Area)._id || "",
          email: selected.email,
          region: (selected.district as Distrito).region as string,
        },
        true
      );
    }
  }, []);

  useEffect(() => {
    if (values.region) getDistritos();
  }, [values.region]);

  async function save() {
    const method = selected ? "PUT" : "POST";
    const rute = selected ? `/${selected._id}` : "";
    setLoading(true);
    const params: any = { ...values };
    delete params.region;
    if (!values.pArea) delete params.pArea;
    if (!values.email) delete params.email;
    delete params.region;
    const res = await peticionBack(
      params,
      "/areas" + rute,
      method,
      true,
      toaster
    );
    if (res) handleReset(null);
    setLoading(false);
  }

  return (
    <form onSubmit={handleSubmit} onReset={handleReset}>
      <Row>
        <Col xs={12} md={6}>
          <InputForm
            label="Nombre área"
            name="name"
            type="text"
            value={values.name}
            touched={touched.name}
            error={errors.name}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            required
          />
        </Col>
        <Col xs={12} md={6}>
          <InputForm
            label="Clave"
            name="areaKey"
            type="text"
            value={values.areaKey}
            touched={touched.areaKey}
            error={errors.areaKey}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
          />
        </Col>
        <Col xs={12} md={6}>
          <InputForm
            label="Correo"
            name="email"
            type="text"
            value={values.email}
            touched={touched.email}
            error={errors.email}
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
          />
        </Col>
        <Col xs={12} md={6}>
          <InputSearch
            label="Área"
            name="pArea"
            value={values.pArea as string}
            touched={touched.pArea}
            error={errors.pArea}
            values={areas}
            labelVal="name"
            valueVal="_id"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
          />
        </Col>
        <Col xs={12} md={6}>
          <InputSearch
            label="Instancia"
            name="instance"
            value={values.instance as string}
            touched={touched.instance}
            error={errors.instance}
            values={instancias}
            labelVal="name"
            valueVal="_id"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            required
          />
        </Col>
        <Col xs={12} md={6}>
          <InputSearch
            label="Regiones"
            name="region"
            value={values.region as string}
            touched={touched.region}
            error={errors.region}
            values={regiones}
            labelVal="name"
            valueVal="_id"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            required
          />
        </Col>
        <Col xs={12} md={6}>
          <InputSearch
            label="Distritos"
            name="district"
            value={values.district as string}
            touched={touched.district}
            error={errors.district}
            values={distritos[values.region as string] || []}
            labelVal="name"
            valueVal="_id"
            onChangeMethod={onChange}
            onBlurMethod={handleBlur}
            required
            disabled={!values.region}
          />
        </Col>
      </Row>

      <div className="d-grid gap-2 d-md-flex justify-content-md-around mt-2">
        <Button variant="danger" type="reset">
          Cancelar
        </Button>
        <Button variant="success" type="submit">
          Guardar
        </Button>
      </div>

      {loading && <Loader backdrop vertical style={{ zIndex: 5 }} />}
    </form>
  );
}

interface AreaForm extends Area {
  region: string;
}
